export const websiteRouteSegments = {
  home: "home",
  about: "about",
  contact: "contact",
  services: "services",
  projects: "projects",
  residential: "residential",
  commercial: "commercial",
  industrial: "industrial",
  all: "all",
  completed: "completed",
  safetyCompliance: "safety-compliance",
  reviews: "reviews",
  videos: "videos",
} as const;

export const websitePaths = {
  home: `/${websiteRouteSegments.home}`,
  about: `/${websiteRouteSegments.about}`,
  contact: `/${websiteRouteSegments.contact}`,
  services: `/${websiteRouteSegments.services}`,
  serviceDetails: (slug: string) => `/${websiteRouteSegments.services}/${slug}`,
  projects: {
    root: `/${websiteRouteSegments.projects}`,
    residential: `/${websiteRouteSegments.projects}/${websiteRouteSegments.residential}`,
    commercial: `/${websiteRouteSegments.projects}/${websiteRouteSegments.commercial}`,
    industrial: `/${websiteRouteSegments.projects}/${websiteRouteSegments.industrial}`,
    all: `/${websiteRouteSegments.projects}/${websiteRouteSegments.all}`,
    completed: `/${websiteRouteSegments.projects}/${websiteRouteSegments.completed}`,
  },
  safetyCompliance: `/${websiteRouteSegments.safetyCompliance}`,
  reviews: {
    videos: `/${websiteRouteSegments.reviews}/${websiteRouteSegments.videos}`,
  },
} as const;
